import React, { useContext, useEffect, useState } from "react";
import { AppBar, Container, Toolbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import UserContext from "../../context/UserContext";
import LinksTopBar from "./LinksTopBar";
import { logoutUser } from "../../network/user";
import { withStyles } from "@mui/styles";
import Logo from "./Logo";
import {
  TABLET_BODY_CLASS,
  TABLET_CHROME_EVENT,
} from "../pages/Tournament/League/planillero-tablet-chrome";
import { isPublicEventBoardPath } from "constants/routes";

const styles = (theme) => ({
  appBar: {
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
});

const Header = () => {
  const location = useLocation();
  const { changeUser } = useContext(UserContext);
  const [tabletChrome, setTabletChrome] = useState(() =>
    typeof document !== "undefined" ? document.body.classList.contains(TABLET_BODY_CLASS) : false,
  );

  useEffect(() => {
    const onChange = (event) => setTabletChrome(Boolean(event.detail));
    window.addEventListener(TABLET_CHROME_EVENT, onChange);
    return () => window.removeEventListener(TABLET_CHROME_EVENT, onChange);
  }, []);

  const handleLogoutClick = () => {
    logoutUser(changeUser);
  };

  // Ocultar el Header en ciertas rutas
  const hiddenRoutes = ["/landing", "/signin", "/register", "/forgot-password"];
  const hiddenMenusRoutes = ["/admin/event", "/admin/organizations", "/admin/gestion", "/organization"];
  const hideHeader =
    hiddenRoutes.includes(location.pathname) || tabletChrome || isPublicEventBoardPath(location.pathname);
  const hideProfile = hiddenMenusRoutes.some((route) => location.pathname.startsWith(route));

  if (hideHeader) {
    return null;
  }

  return (
    <AppBar position="static" sx={{ ...styles.appBar }}>
      <Container maxWidth={hideProfile ? false : "lg"} sx={{ height: 64, px: hideProfile ? 2 : undefined }}>
        <Toolbar
          disableGutters
          sx={{ justifyContent: hideProfile ? "flex-end" : "space-between", gap: 2, minHeight: 64 }}
        >
          {!hideProfile && <Logo />}
          <LinksTopBar handleLogoutClick={handleLogoutClick} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default withStyles(styles)(Header);
